import type { ServiceDefinition } from '~/types/report-service'

export const TEMPLATE_ID_PREFIX = 'tpl:'

export const isTemplateId = (id: string | null | undefined): boolean => !!id && id.startsWith(TEMPLATE_ID_PREFIX)

export const definitionRoute = (id: string): string => `/reports/custom/${id}`

export const definitionEditRoute = (id: string): string => `/reports/custom/${id}/edit`

export interface DefinitionGroups {
  mine: ServiceDefinition[]
  shared: ServiceDefinition[]
}

export const splitDefinitions = (
  definitions: ServiceDefinition[] | null | undefined,
  userId: number | string | null | undefined
): DefinitionGroups => {
  const owner = userId === null || userId === undefined ? null : Number(userId)
  const groups: DefinitionGroups = { mine: [], shared: [] }

  for (const definition of definitions ?? []) {
    if (isTemplateId(definition.id)) continue
    if (owner !== null && Number.isFinite(owner) && definition.ownerId === owner) groups.mine.push(definition)
    else groups.shared.push(definition)
  }

  return groups
}

const escapeForRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const duplicateName = (name: string, t: (key: string) => string): string => {
  const copy = t('reports.custom.copyOf').trim() || 'copy'
  const pattern = new RegExp(`\\s\\(${escapeForRegExp(copy)}(?:\\s(\\d+))?\\)$`, 'i')
  const match = pattern.exec(name)

  if (!match) return `${name} (${copy})`

  const previous = match[1] ? Number(match[1]) : 1
  return `${name.slice(0, match.index)} (${copy} ${previous + 1})`
}
